<template>
  <v-navigation-drawer
    app
    right
    clipped
    width="290"
    v-model="model"
  >
    <div class="mt-4 mx-3">
      <div class="d-flex align-center justify-space-between mb-4">
        <span class="subtitle-2 font-weight-bold">
          Filters
        </span>
        <v-btn icon small @click="setDrawer(false)">
          <v-icon small>mdi-close</v-icon>
        </v-btn>
      </div>

      <!-- Machine Filter -->
      <v-select
        :value="filterMachine"
        :items="machineOptions"
        label="Machine"
        dense
        outlined
        class="mb-3"
        @change="setFilterMachine"
      />

      <!-- Part Filter -->
      <v-select
        :value="filterPart"
        :items="partOptions"
        label="Part"
        dense
        outlined
        class="mb-3"
        @change="setFilterPart"
      />

      <!-- Month Filter -->
      <v-select
        :value="filterMonth"
        :items="formattedMonthOptions"
        item-text="text"
        item-value="value"
        label="Month"
        dense
        outlined
        class="mb-3"
        @change="setFilterMonth"
      />

      <!-- Color Filter -->
      <v-select
        :value="filterColor"
        :items="colorOptions"
        label="Color"
        dense
        outlined
        class="mb-3"
        @change="setFilterColor"
      />

      <!-- Weight Unit Filter -->
      <v-select
        :value="weightUnit"
        :items="weightUnitOptions"
        label="Weight Unit"
        dense
        outlined
        class="mb-3"
        @change="setWeightUnit"
      />

      <!-- Reset Filters -->
      <v-btn
        block
        outlined
        small
        color="primary"
        class="text-none"
        @click="resetFilters"
      >
        <v-icon left small>mdi-refresh</v-icon>
        Reset Filters
      </v-btn>
    </div>
  </v-navigation-drawer>
</template>

<script>
import { mapState, mapGetters, mapMutations } from 'vuex';

export default {
  name: 'FilterDrawer',
  computed: {
    ...mapState('monthlyPlanning', [
      'drawer',
      'filterMachine',
      'filterPart',
      'filterMonth',
      'filterColor',
      'weightUnit',
    ]),
    weightUnitOptions() {
      return [
        { text: 'Grams', value: 'grams' },
        { text: 'Kg', value: 'kgs' },
      ];
    },
    ...mapGetters('monthlyPlanning', [
      'machineOptions',
      'partOptions',
      'monthOptions',
      'colorOptions',
    ]),
    formattedMonthOptions() {
      const months = [
        'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
        'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec',
      ];
      return this.monthOptions.map((val) => {
        if (val === 'All') return { text: 'All', value: 'All' };
        const s = String(val);
        const year = s.substring(0, 4);
        const month = parseInt(s.substring(4, 6), 10);
        return {
          text: `${months[month - 1]} ${year}`,
          value: val,
        };
      });
    },
    model: {
      get() {
        return this.drawer;
      },
      set(val) {
        this.setDrawer(val);
      },
    },
  },
  methods: {
    ...mapMutations('monthlyPlanning', [
      'setDrawer',
      'setFilterMachine',
      'setFilterPart',
      'setFilterMonth',
      'setFilterColor',
      'setWeightUnit',
    ]),
    resetFilters() {
      this.setFilterMachine('All');
      this.setFilterPart('All');
      this.setFilterMonth('All');
      this.setFilterColor('All');
      this.setWeightUnit('kgs');
    },
  },
};
</script>
